<template>
    <div>
        <el-backtop>
            <i class="el-icon-top" style="color: #e70a16;"></i>
        </el-backtop>
    </div>
</template>
<script>
export default {
    data() {
        return {
        }
    },
    created() {
    },
    computed: {
    },
    methods: {
    },
}
</script>
<style lang="scss" scoped>
.el-backtop {right: 2% !important;}
</style>
